var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessCompliance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#06966B",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8426 8.36126C17.1941 8.71273 17.1941 9.28258 16.8426 9.63401L10.8426 15.634C10.4911 15.9855 9.92137 15.9855 9.56985 15.634L7.16985 13.234C6.81838 12.8825 6.81838 12.3128 7.16985 11.9613C7.52132 11.6098 8.09117 11.6098 8.44264 11.9613L10.2062 13.7248L12.888 11.0431L15.5699 8.36126C15.9214 8.00979 16.4911 8.00979 16.8426 8.36126Z",
    fill: "#06966B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCompliance);
export default __webpack_public_path__ + "static/media/successCompliance.fbde53ba8d76ceaf9eb45dbacd204dad.svg";
export { ForwardRef as ReactComponent };